import { getStorage, ref as storageRef, uploadBytes, getDownloadURL } from "firebase/storage";
import {User} from "firebase/auth";

async function fetchWithRetry(url: string, retries = 5, delay = 1000): Promise<Response> {
  for (let attempt = 1; attempt <= retries; attempt++) {
    const response = await fetch(url+"?123",{
      headers: {
        "User-Agent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/91.0.4472.124 Safari/537.36",
      },
    });
    if (response.status === 429) {
      console.warn(`429 Too Many Requests. Retrying in ${delay}ms...`);
      await new Promise((resolve) => setTimeout(resolve, delay));
      delay *= 2; // Exponential backoff
    } else {
      return response;
    }
  }
  throw new Error(`Failed to fetch ${url} after ${retries} retries.`);
}

export const processUserAvatar =  async (user: User): Promise<string> => {
  const storage = getStorage();
  const avatarPath = `avatars/${user.uid}.jpg`;
  const avatarRef = storageRef(storage, avatarPath);

  try {
    // Fetch the Google avatar
    if (user.photoURL) {
      console.log("Downloading...");
      const response = await fetchWithRetry(user.photoURL);
      console.log(response);
      if(response.status >= 200 && response.status < 300) {
        const avatarBlob = await response.blob();
        console.log(avatarBlob.type);
        // Upload the avatar to Firebase Storage
        await uploadBytes(avatarRef, avatarBlob);

        // Get the Firebase Storage URL
        const firebaseAvatarUrl = await getDownloadURL(avatarRef);

        // Return a new user object with the updated photoURL
        return firebaseAvatarUrl;
        }
    }
  } catch (error) {
    console.error("Error processing avatar:", error);
  }

  // Return the user as-is if something goes wrong
  return "";
}